"use strict";

import BigPicture from "bigpicture";

document.querySelector(".section_menutoggle").addEventListener("click", () => {
    document.body.classList.toggle("navigation--showmenu");
});

if (document.getElementsByClassName("section--newsitems")) {
    const elements = document.querySelectorAll(".section--newsitems .newsitem");
    const temp = [];
    elements.forEach((value, index) => {
        // Original height > push to array
        temp.push(elements[index].querySelector(".expandable").clientHeight);
        const expandable = elements[index].querySelector(
            ".textcontainer .expandable"
        );
        const expandable_newheight = expandable.clientHeight;
        elements[index]
            .querySelector(".expandable")
            .classList.toggle("expandablehidden");
        expandable.style.cssText = `max-height:${expandable_newheight * 2}px;`;
        // Event listener
        if (elements[index].querySelector(".extend")) {
            elements[index]
                .querySelector(".extend")
                .addEventListener("click", () => {
                    elements[index]
                        .querySelector(".extend")
                        .classList.toggle("extendtoggled");
                    elements[index]
                        .querySelector(".expandable")
                        .classList.toggle("expandablehidden");
                    if (
                        elements[index]
                            .querySelector(".extend")
                            .classList.contains("extendtoggled")
                    ) {
                        elements[index].querySelector(".extend").innerHTML =
                            "weniger anzeigen";
                    } else {
                        elements[index].querySelector(".extend").innerHTML =
                            "mehr anzeigen";
                    }
                });
        }
    });
}

var elements = [...document.querySelectorAll('[data-behaviour="lightbox"]')];

elements.forEach(elem => {
    elem.addEventListener("click", e => {
        e.preventDefault();
        BigPicture({
            el: e.target,
            // ytSrc: 'z_PeaHVcohg',
            // imgSrc: elem.href,
            gallery: e.target.parentNode.parentNode.querySelectorAll("img")
        });
    });
});

const navigations = document.querySelectorAll(".gallery_nav");

navigations.forEach(nav => {
    const images = nav.parentNode.querySelector(".gallery_images");
    const fwd = nav.querySelector(".gallery_nav_fwd");
    const bwd = nav.querySelector(".gallery_nav_bwd");

    fwd.addEventListener("click", () => {
        const currentScroll = images.scrollLeft;
        [...images.children].some(image => {
            const pos = image.offsetLeft;
            if (pos - 1 > currentScroll) {
                images.scroll({
                    top: 0,
                    left: pos,
                    behavior: "smooth"
                });
                return true;
            }
        });
    });
    bwd.addEventListener("click", () => {
        const currentScroll = images.scrollLeft;
        console.log(currentScroll);

        [...images.children].reverse().some(image => {
            const pos = image.offsetLeft;
            if (pos + 1 < currentScroll) {
                images.scroll({
                    top: 0,
                    left: pos,
                    behavior: "smooth"
                });
                return true;
            }
        });
    });
});

// Members element
if (document.querySelector(".section--members")) {
    const parent = document.querySelector(".section--members");
    const child = parent.querySelectorAll(".memberlist .member");
    const accordion = parent.querySelectorAll(
        ".memberlist .member .info .info_accordion"
    );
    const button = parent.querySelectorAll(".memberlist .member .info .toggle");
    const buttonimg = parent.querySelectorAll(
        ".memberlist .member_holder .image_holder img"
    );
    const buttonheader = parent.querySelectorAll(
        ".memberlist .member .member_holder .info h3"
    );

    // MaxHeight Setter
    child.forEach((v, i) => {
        const child_height = accordion[i].clientHeight * 2;
        accordion[i].style.cssText = `max-height:${child_height}px;`;
        accordion[i].classList.toggle("info_accordion--hidden");
    });
    // Event listener
    button.forEach((v, i) => {
        button[i].addEventListener("click", () => {
            accordion[i].classList.toggle("info_accordion--hidden");
            button[i].classList.toggle("toggle--inverse");
        });
    });
    buttonimg.forEach((v, i) => {
        buttonimg[i].addEventListener("click", () => {
            console.log(i);
            accordion[i].classList.toggle("info_accordion--hidden");
            button[i].classList.toggle("toggle--inverse");
        });
    });
    buttonheader.forEach((v, i) => {
        buttonheader[i].addEventListener("click", () => {
            accordion[i].classList.toggle("info_accordion--hidden");
            button[i].classList.toggle("toggle--inverse");
        });
    });
}
